export default {
  text: 'black',
  primary: '#c61b02',
  secondary: '#c61b02',
  background: 'white',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
